import CustomInput from "components/CustomInput";
import { selectIsOwner, selectUserId } from "features/user/userSlice";
import { useGetUserLotRelationsForUserQuery, useGetUserRoleQuery, useUpdateUserInformationMutation } from "features/users/usersSlice";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import UsersPageStyle from "../../UsersPageStyle";
import { useGetAllRolesQuery } from "components/Authorize/rolesSlice";
import { Button, FormControlLabel, Grid, Paper, Checkbox } from "@material-ui/core";
import ResetPasswordDialog from "../resetPassword/resetPasswordDialog";
import NotificationProvider from "components/NotificationProvider";
import Authorize from "../../../../../components/Authorize";
import SendRestorePasswordDialog from "../sendRestorePassword/sendRestorePasswordDialog";
import {permissionProfiles} from "../../../../../components/Authorize/permissionProfiles";

const useStyles = UsersPageStyle;

const EditUserInformation = ({ user, userClaims }) => {
    const classes = useStyles();

    const userId = useSelector(selectUserId);

    let { data: userLotRelations, error: relationsError, isLoading: isLoadingRelations } = useGetUserLotRelationsForUserQuery(userId, { skip: !userId });
    let { data: roles, error: roleError, isLoading: isLoadingRoles } = useGetAllRolesQuery()
    let { data: userRole, error: userRoleError, isLoading: isLoadingUserRole } = useGetUserRoleQuery(user?.id, { skip: !user?.id });

    userLotRelations = userLotRelations || [];
    roles = roles?.data || [];
    userRole = userRole || [];

    const [updateInformation] = useUpdateUserInformationMutation()
    const [hasChanged, setHasChanged] = useState(false);
    const [saving, setSaving] = useState(false);
    const [roleId, setRoleId] = useState();
    const [fullName, setFullName] = useState("");
    const [userArchive, setUserArchive] = useState(false);
    const [userBlackList, setUserBlackList] = useState(false);
    const [openResetDialog, setOpenResetDialog] = useState(false);
    const [openRestoreDialog, setOpenRestoreDialog] = useState(false);

    useEffect(() => {
        let name = userClaims?.find(c => c.claimType === 'name')?.claimValue ?? '';
        setFullName(name ?? "");
    }, [userClaims])

    useEffect(() => {
        if (!isLoadingUserRole) {
            setRoleId(userRole?.data?.[0]?.roleId ?? "");
        }
        setUserArchive(user?.lockoutEnabled);
        setUserBlackList(user?.isBlackList);
    }, [user?.id, isLoadingUserRole])

    const handleUserInfoSave = async () => {
        setSaving(true);

        const objToSend = {
            userId: user?.id,
            roleId: roleId,
            fullName: fullName,
            lockoutEnabled: userArchive,
            isBlackList: userBlackList
        }

        let result = await updateInformation(objToSend);

        setSaving(false);

        if (!result?.error) {
            NotificationProvider.success('Saved successfully');
        } else {
            NotificationProvider.error('Failed to save');
        }

        setHasChanged(false);
    }

    const isOwner = useSelector(selectIsOwner);

    let isRM = userLotRelations?.find(u => u.relationType === 3); //lot association with rm
    let isSuper = userLotRelations?.find(u => u.relationType === 2);

    const getRoleValues = () => {
        if (isRM && isOwner) {
            return roles?.filter(r => r?.name === "account_manager" || r?.name === "admin");
        }
        if (isSuper) {
            return roles?.filter(r => r?.name === "admin");
        }
        if (isOwner && !isRM) {
            return roles;
        }
    }

    const onClickReset = () => {
        setOpenResetDialog(true);
    }

    const onClickRestorePassword = () => {
        setOpenRestoreDialog(true);
    }

    return (
        <Paper className={classes.paper}>
            <div className={classes.label}>User Information</div>

            <Grid container className={classes.wrapperSave}>
                <Authorize profile={permissionProfiles.USER.USER_RESTORE_PASSWORD}>
                    <Grid item>
                        <Button
                            className={classes.resetButton}
                            onClick={onClickReset}
                            color="primary"
                            variant="contained"
                        >
                            Reset Password
                        </Button>
                    </Grid>
                </Authorize>
                <Grid item>
                    <Button
                        className={classes.resetButton}
                        onClick={onClickRestorePassword}
                        color="primary"
                        variant="contained"
                    >
                        Send Restore Password
                    </Button>
                </Grid>
  
            </Grid>
            <Grid item className={classes.grids}>
                <CustomInput
                    id="userName"
                    label="Username"
                    elementType="input"
                    classStyles={classes.dropdown}
                    value={user?.userName}
                    disabled
                />
            </Grid>
            <Grid item className={classes.grids}>
                <CustomInput
                    id="name"
                    label="Full Name"
                    elementType="input"
                    classStyles={classes.dropdown}
                    onChange={(val) => { setFullName(val); setHasChanged(true); }}
                    value={fullName}
                />
            </Grid>
            <Grid item className={classes.grids}>
                <CustomInput
                    id="email"
                    label="Email"
                    elementType="input"
                    classStyles={classes.dropdown}
                    disabled
                    value={user?.email}
                />
            </Grid>
            <Grid item className={classes.grids}>
                <CustomInput
                    id="role"
                    label="Role"
                    elementType="dropdown"
                    values={[{ id: '', name: "" }, ...(getRoleValues() ?? [])]}
                    onChange={val => { setRoleId(val); setHasChanged(true); }}
                    touched
                    value={roleId ?? ""}
                />
            </Grid>
            <Authorize profile={permissionProfiles.USER_MANAGEMENT.ARCHIVE_USER}>
                <Grid item className={classes.grids}>
                        <FormControlLabel
                        control={<Checkbox checked={userArchive} onChange={(e, value) => { setUserArchive(value); setHasChanged(true); } } />}
                        label={userArchive ? `User Archived (Uncheck to reactive user)` : `Archive User`}/>
                </Grid>
            </Authorize>
            {/* <Authorize profile={permissionProfiles.USER.BLACKLIST_USER}>
                <Grid item className={classes.grids}>
                    <FormControlLabel
                        control={<Checkbox checked={userBlackList} onChange={(e, value) => { setUserBlackList(value); setHasChanged(true); } } />}
                        label={userBlackList ? `Is in Black List (Uncheck to reactive user)` : `Add to the Black List`}/>
                </Grid>
            </Authorize> */}
            
            <Grid container className={classes.wrapperSave}>
                {hasChanged ?
                    <Grid item>
                        <Button
                            className={classes.resetButton}
                            onClick={handleUserInfoSave}
                            color="primary"
                            variant="contained"
                            disabled={saving}
                        >
                            {saving ? 'Saving...' : 'Save'}
                        </Button>
                    </Grid> : null
                }
            </Grid>
            <SendRestorePasswordDialog
                open={openRestoreDialog}
                setOpenDialog={setOpenRestoreDialog}
                userId={user?.id}
            />
            
            <ResetPasswordDialog open={openResetDialog} setOpenDialog={setOpenResetDialog} userId={user?.id}></ResetPasswordDialog>

        </Paper>
    )
}

export default EditUserInformation;